import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    // Navigation
    nav_home: "Home",
    nav_programme: "Programme",
    nav_services: "Services",
    nav_facilities: "Facilities",
    nav_doctors: "Our Experts",
    nav_procedures: "Procedures",
    nav_clinics: "Clinics",
    nav_contact: "Contact",
    book_appointment: "Book Appointment",
    
    // Hero
    hero_title: "Transform Your Life",
    hero_subtitle: "Comprehensive Obesity Care",
    hero_description: "Expert-led weight loss solutions combining advanced medical technology with personalized care at GastroCare Bhopal.",
    hero_cta: "Start Your Journey",
    hero_call: "Call Now",
    
    // Challenge Section
    challenge_title: "The Obesity Challenge",
    challenge_subtitle: "Understanding the Health Impact",
    challenge_description: "Obesity is a complex, chronic disease and a global health challenge. Beyond physical weight, it multiplies the risk of type 2 diabetes, cardiovascular diseases, and hypertension. Our programme at Gastrocare Hospital Bhopal is designed to address these consequences through medical and surgical precision.",
    challenge_stat1: "Type 2 Diabetes",
    challenge_stat2: "Heart Disease",
    challenge_stat3: "Hypertension",
    challenge_stat1_desc: "3x higher risk with obesity",
    challenge_stat2_desc: "2x increased cardiovascular risk",
    challenge_stat3_desc: "6x higher blood pressure risk",
    
    // Programme
    programme_title: "Our Obesity Programme",
    programme_subtitle: "A Multi-Disciplinary Approach",
    programme_description: "A comprehensive, multi-disciplinary approach focused on sustainable weight loss and metabolic health. We combine advanced diagnostic equipment with personalised care paths.",
    programme_feature1: "Personalized Care Plans",
    programme_feature2: "Advanced Diagnostics",
    programme_feature3: "Expert Medical Team",
    programme_feature4: "Long-term Support",
    
    // Services
    services_title: "Our Services",
    services_subtitle: "Comprehensive Weight Loss Solutions",
    service1_title: "Nutritional Counselling",
    service1_desc: `Tailored dietary plans managed by expert dietitians. Personalized nutrition strategies for sustainable weight management.`, 
    service2_title: "Endobariatric",
    service2_desc: "Non-surgical, incisionless procedures for weight loss. Advanced endoscopic techniques with minimal recovery time.",
    service3_title: "Bariatric Surgery",
    service3_desc: "Advanced minimally invasive surgeries for long-term results. Performed by experienced laparoscopic surgeons.",
     service4_title: "GLP-1 services",
//     service4_desc:  `GLP-1 Drug Overdose - poisonhelp.org
// Our program includes GLP-1 uses for the treatment of type 2 diabetes associated with obesity on a case-by-case basis. We have extensive experience with the usage of GLP-1 agonists, showing good results in appropriately selected cases.

// GLP-1 receptor agonists (such as Semaglutide, Tirzepatide, and Liraglutide) are a powerful class of medications used to manage type 2 diabetes and obesity by reducing blood sugar, slowing digestion, and suppressing appetite. Common brands include Ozempic, Wegovy, Mounjaro, and Trulicity, which are typically administered via weekly or daily injections, with some oral options available. The primary side effects are gastrointestinal, including nausea, vomiting, and diarrhea.

// Common GLP-1 Receptor Agonist Medications

// Semaglutide (Weekly Injection: Wegovy, Ozempic; Daily Pill: Rybelsus)
// Tirzepatide (Weekly Injection: Mounjaro, Zepbound)
// Liraglutide (Daily Injection: Victoza, Saxenda)
// Dulaglutide (Weekly Injection: Trulicity)
// Exenatide (Daily/Weekly Injection: Byetta, Bydureon)

// How They Work and Approved Uses
// GLP-1s mimic the GLP-1 hormone, signaling the pancreas to release insulin, slowing stomach emptying, and increasing feelings of fullness. They are approved by authorities for:

// Type 2 Diabetes Control: Lowering hemoglobin A1c.
// Weight Management: Chronic weight management in adults with obesity or overweight.
// Cardiovascular Protection: Reducing the risk of major cardiovascular events, such as heart attack or stroke, in adults with type 2 diabetes.

// Common Side Effects
// While effective, these drugs are associated with side effects, often decreasing over time:

// Gastrointestinal Issues: Nausea, vomiting, diarrhea, constipation, and abdominal pain.
// Other Potential Effects: Decreased appetite, fatigue, and headaches.
// Serious Risks: Although rare, risks can include pancreatitis, gallbladder problems, and hypoglycemia (if combined with other diabetes medications).

// Administration and Future Options
// Most approved GLP-1 drugs are given by injection, though oral forms like Rybelsus exist. New, faster-acting, and better-tolerated pill-based forms are currently in development.
// `,
//     learn_more: "Learn More",

service4_desc:`We offer modern, evidence-based medications such as GLP-1 receptor agonists (including semaglutide and tirzepatide) for selected patients with obesity and metabolic disease.

These medications help:
1. Reduce appetite
2. Improve blood sugar control
3. Promote gradual, sustained weight loss

What results can you expect?

Clinical studies have shown:
•GLP-1 based medications:
Average weight loss of 10–20% of body weight over 6–12 months
•In some patients (especially with newer therapies like tirzepatide):
Weight loss may approach 20–25% under medical supervision

Who is this treatment suitable for?
•BMI ≥ 30
•BMI ≥ 27 with conditions like diabetes, fatty liver, or hypertension
•Patients who have not achieved adequate results with lifestyle changes alone`, learn_more: "Learn More",
    
    // Facilities
    facilities_title: "World-Class Facilities",
    facilities_subtitle: "State-of-the-Art Infrastructure",
    facility1_title: "100-Bed Hospital",
    facility1_desc: "Modern facility with fully modular operation theatres and specialized ICUs equipped with HEPA filters for optimal patient care.",
    facility2_title: "Advanced Diagnostics",
    facility2_desc: "In-house Radiology including CT Scan and USG, along with Hi-tech Pathology Lab for comprehensive pre-operative workups.",
    facility3_title: "Specialized ICU",
    facility3_desc: "Dedicated intensive care units with HEPA filtration systems ensuring the highest standards of post-operative care.",
    
    // Doctors
    doctors_title: "Our Expert Team",
    doctors_subtitle: "Led by Pioneers in Their Fields",
    doctor1_name: "Chief Dietitian",
    doctor1_role: "Metabolic Nutrition Specialist",
    doctor1_desc: "Specialized in metabolic nutrition with years of experience in creating personalized dietary plans.",
    doctor2_name: "Dr. Sanjay Kumar",
    doctor2_role: "Program Director - Endobariatric",
    doctor2_desc: "A pioneer in therapeutic endoscopy, leading our non-surgical weight loss procedures.",
    doctor3_name: "Dr. Sandesh Sharma",
    doctor3_role: "Bariatric and Laparoscopic Surgery Specialist",
    doctor3_desc: "Skilled laparoscopic surgeon specializing in minimally invasive weight loss surgeries.",
    doctor4_name: "Dr. Vishu jain",
    doctor4_role: "Assitant program coordintor",
    doctor4_desc: "Expert in laparoscopic, Bariatric GI surgery with experience in advanced bariatric procedures.",
    
    // Procedures
    procedures_title: "Procedures Offered",
    procedures_subtitle: "Advanced Surgical & Endoscopic Options",
    endoscopic_title: "Endoscopic Procedures",
    surgical_title: "Surgical Procedures",
    procedure1: "Endoscopic Sleeve Gastroplasty (ESG)",
    procedure2: "Gastric Balloon",
    procedure3: "Laparoscopic Sleeve Gastrectomy",
    procedure4: "Gastric Bypass",
    procedure5: "Mini Gastric Bypass",
    
    // Clinics
    clinics_title: "Special Clinics",
    clinics_subtitle: "Integrated Disease Management",
    clinic1_title: "Metabolic Clinic",
    clinic1_desc: "Specialized clinic for metabolic syndrome management and prevention.",
    clinic2_title: "Diabesity Clinic",
    clinic2_desc: "Dedicated clinic for integrated management of diabetes and obesity-related comorbidities.",
    
    // Contact
    contact_title: "Book Your Appointment",
    contact_subtitle: "Start Your Transformation Today",
    contact_address: "120-121, E-3, Arera Colony, Bhopal",
    contact_phone1: "+91-755-4055123",
    contact_phone2: "+91-9300951215",
    contact_online: "Online Booking",
    contact_online_desc: "Book your appointment online and take the first step towards a healthier you. Our team will contact you to confirm your booking and discuss your needs.",
    form_name: "Full Name",
    form_email: "Email Address",
    form_phone: "Phone Number",
    form_service: "Select Service",
    form_date: "Preferred Date",
    form_message: "Your Message (Optional)",
    form_submit: "Submit Appointment Request",
    form_success: "Thank you! We will contact you soon.",
    
    // Footer
    footer_tagline: "Transforming Lives Through Expert Obesity Care",
    footer_rights: "All Rights Reserved",
    footer_disclaimer: "This is for informational purposes only. For medical advice or diagnosis, consult a professional.",
    
    // WhatsApp
    whatsapp_text: "Chat with us",
  },
  hi: {
    // Navigation
    nav_home: "होम",
    nav_programme: "कार्यक्रम",
    nav_services: "सेवाएं",
    nav_facilities: "सुविधाएं",
    nav_doctors: "हमारे विशेषज्ञ",
    nav_procedures: "प्रक्रियाएं",
    nav_clinics: "क्लीनिक",
    nav_contact: "संपर्क",
    book_appointment: "अपॉइंटमेंट बुक करें",
    
    // Hero
    hero_title: "अपना जीवन बदलें",
    hero_subtitle: "व्यापक मोटापा देखभाल",
    hero_description: "गैस्ट्रोकेयर भोपाल में उन्नत चिकित्सा तकनीक के साथ व्यक्तिगत देखभाल को मिलाकर विशेषज्ञ नेतृत्व में वजन घटाने के समाधान।",
    hero_cta: "अपनी यात्रा शुरू करें",
    hero_call: "अभी कॉल करें",
    
    // Challenge Section
    challenge_title: "मोटापे की चुनौती",
    challenge_subtitle: "स्वास्थ्य प्रभाव को समझना",
    challenge_description: "मोटापा एक जटिल, पुरानी बीमारी और वैश्विक स्वास्थ्य चुनौती है। शारीरिक वजन से परे, यह टाइप 2 मधुमेह, हृदय रोगों और उच्च रक्तचाप के जोखिम को कई गुना बढ़ा देता है। गैस्ट्रोकेयर भोपाल में हमारा कार्यक्रम चिकित्सा और शल्य चिकित्सा सटीकता के माध्यम से इन परिणामों को संबोधित करने के लिए डिज़ाइन किया गया है।",
    challenge_stat1: "टाइप 2 मधुमेह",
    challenge_stat2: "हृदय रोग",
    challenge_stat3: "उच्च रक्तचाप",
    challenge_stat1_desc: "मोटापे के साथ 3 गुना अधिक जोखिम",
    challenge_stat2_desc: "2 गुना बढ़ा हृदय जोखिम",
    challenge_stat3_desc: "6 गुना अधिक रक्तचाप जोखिम",
    
    // Programme
    programme_title: "हमारा मोटापा कार्यक्रम",
    programme_subtitle: "एक बहु-विषयक दृष्टिकोण",
    programme_description: "स्थायी वजन घटाने और चयापचय स्वास्थ्य पर केंद्रित एक व्यापक, बहु-विषयक दृष्टिकोण। हम उन्नत नैदानिक उपकरणों को व्यक्तिगत देखभाल पथों के साथ जोड़ते हैं।",
    programme_feature1: "व्यक्तिगत देखभाल योजनाएं",
    programme_feature2: "उन्नत निदान",
    programme_feature3: "विशेषज्ञ चिकित्सा टीम",
    programme_feature4: "दीर्घकालिक सहायता",
    
    // Services
    services_title: "हमारी सेवाएं",
    services_subtitle: "व्यापक वजन घटाने के समाधान",
    service1_title: "पोषण परामर्श",
    service1_desc: "विशेषज्ञ आहार विशेषज्ञों द्वारा प्रबंधित अनुकूलित आहार योजनाएं। स्थायी वजन प्रबंधन के लिए व्यक्तिगत पोषण रणनीतियां।",
    service2_title: "एंडोबैरिएट्रिक",
    service2_desc: "वजन घटाने के लिए गैर-सर्जिकल, बिना चीरे की प्रक्रियाएं। न्यूनतम रिकवरी समय के साथ उन्नत एंडोस्कोपिक तकनीकें।",
    service3_title: "बैरिएट्रिक सर्जरी",
    service3_desc: "दीर्घकालिक परिणामों के लिए उन्नत न्यूनतम इनवेसिव सर्जरी। अनुभवी लेप्रोस्कोपिक सर्जनों द्वारा की जाती है।", 
    service4_title: "जीएलपी-1 सेवाएं",
    service4_desc:`जीएलपी-1 दवा की अधिक मात्रा - poisonhelp.org
हमारा कार्यक्रम मोटापे से जुड़े टाइप-2 मधुमेह के उपचार के लिए जीएलपी-1 के उपयोग को शामिल करता है। हम हर मामले के आधार पर जीएलपी-1 एगोनिस्ट के उपयोग का व्यापक अनुभव रखते हैं और उपयुक्त चयनित मामलों में अच्छे परिणाम प्राप्त हुए हैं।

जीएलपी-1 रिसेप्टर एगोनिस्ट (जैसे सेमाग्लूटाइड, तिरजेपेटाइड और लिराग्लूटाइड) टाइप 2 मधुमेह और मोटापे को नियंत्रित करने के लिए इस्तेमाल की जाने वाली दवाओं का एक शक्तिशाली वर्ग है। ये रक्त शर्करा को कम करके, पाचन को धीमा करके और भूख को दबाकर काम करते हैं। आम ब्रांडों में ओज़ेम्पिक, वेगोवी, मौनजारो और ट्रूलिसिटी शामिल हैं, जिन्हें आमतौर पर साप्ताहिक या दैनिक इंजेक्शन के माध्यम से दिया जाता है, कुछ मौखिक विकल्प भी उपलब्ध हैं। प्राथमिक दुष्प्रभाव गैस्ट्रोइंटेस्टाइनल हैं, जिनमें मतली, उल्टी और दस्त शामिल हैं।

सामान्य जीएलपी-1 रिसेप्टर एगोनिस्ट दवाएं
सेमाग्लूटाइड (साप्ताहिक इंजेक्शन: वेगोवी, ओज़ेम्पिक; दैनिक गोली: राइबेल्सस)
टिरज़ेपेटाइड (साप्ताहिक इंजेक्शन: मौनजारो, ज़ेपबाउंड)
लिराग्लूटाइड (दैनिक इंजेक्शन: विक्टोज़ा, सैक्सेंडा)
डुलाग्लूटाइड (साप्ताहिक इंजेक्शन: ट्रूलिसिटी)
एक्सेनाटाइड (दैनिक/साप्ताहिक इंजेक्शन: बायेटा, बायड्यूरॉन)

ये कैसे काम करते हैं और स्वीकृत उपयोग
जीएलपी-1, जीएलपी-1 हार्मोन की तरह काम करते हैं, जो अग्नाशय को इंसुलिन स्रावित करने का संकेत देते हैं, जिससे पेट खाली होने की प्रक्रिया धीमी हो जाती है और पेट भरा हुआ महसूस होता है। इन्हें निम्नलिखित उपयोगों के लिए अनुमोदित किया गया है:
टाइप 2 मधुमेह नियंत्रण: हीमोग्लोबिन A1c को कम करना।
वजन प्रबंधन: मोटापे या अधिक वजन वाले वयस्कों में दीर्घकालिक वजन प्रबंधन।
हृदय संबंधी सुरक्षा: टाइप 2 मधुमेह वाले वयस्कों में दिल का दौरा या स्ट्रोक जैसी प्रमुख हृदय संबंधी घटनाओं के जोखिम को कम करना।
सामान्य दुष्प्रभाव
प्रभावी होने के बावजूद, इन दवाओं के कुछ दुष्प्रभाव होते हैं, जो अक्सर समय के साथ कम हो जाते हैं:
पाचन संबंधी समस्याएं: मतली, उल्टी, दस्त, कब्ज और पेट दर्द।
अन्य संभावित दुष्प्रभाव: भूख कम लगना, थकान और सिरदर्द।
गंभीर जोखिम: हालांकि दुर्लभ, जोखिमों में अग्नाशयशोथ, पित्ताशय की समस्याएं और हाइपोग्लाइसीमिया (यदि अन्य मधुमेह की दवाओं के साथ लिया जाए) शामिल हो सकते हैं।
प्रशासन और भविष्य के विकल्प
अधिकांश स्वीकृत जीएलपी-1 दवाएं इंजेक्शन द्वारा दी जाती हैं, हालांकि राइबेलसस जैसी मौखिक दवाएं भी उपलब्ध हैं। नई, तेजी से असर करने वाली और बेहतर सहनशीलता वाली गोली-आधारित दवाओं पर वर्तमान में काम चल रहा है।`,
    learn_more: "अधिक जानें",
    
    // Facilities
    facilities_title: "विश्व स्तरीय सुविधाएं",
    facilities_subtitle: "अत्याधुनिक बुनियादी ढांचा",
    facility1_title: "100-बेड अस्पताल",
    facility1_desc: "पूर्ण मॉड्यूलर ऑपरेशन थिएटर और HEPA फिल्टर से सुसज्जित विशेष ICU के साथ आधुनिक सुविधा।",
    facility2_title: "उन्नत निदान",
    facility2_desc: "CT स्कैन और USG सहित इन-हाउस रेडियोलॉजी, व्यापक प्री-ऑपरेटिव वर्कअप के लिए हाई-टेक पैथोलॉजी लैब।",
    facility3_title: "विशेष ICU",
    facility3_desc: "HEPA फ़िल्ट्रेशन सिस्टम के साथ समर्पित गहन देखभाल इकाइयां जो पोस्ट-ऑपरेटिव देखभाल के उच्चतम मानकों को सुनिश्चित करती हैं।",
    
    // Doctors
    doctors_title: "हमारी विशेषज्ञ टीम",
    doctors_subtitle: "अपने क्षेत्रों में अग्रणी",
    doctor1_name: "मुख्य आहार विशेषज्ञ",
    doctor1_role: "चयापचय पोषण विशेषज्ञ",
    doctor1_desc: "व्यक्तिगत आहार योजनाएं बनाने में वर्षों के अनुभव के साथ चयापचय पोषण में विशेषज्ञ।",
    doctor2_name: "डॉ. संजय कुमार",
    doctor2_role: "कार्यक्रम निदेशक - एंडोबैरिएट्रिक",
    doctor2_desc: "चिकित्सीय एंडोस्कोपी में अग्रणी, हमारी गैर-सर्जिकल वजन घटाने की प्रक्रियाओं का नेतृत्व करते हैं।",
    doctor3_name: "डॉ. कृपा शंकर तिवारी",
    doctor3_role: "कार्यक्रम निदेशक - बैरिएट्रिक सर्जरी",
    doctor3_desc: "उन्नत बैरिएट्रिक प्रक्रियाओं में व्यापक अनुभव के साथ लेप्रोस्कोपिक GI सर्जरी में विशेषज्ञ।",
    doctor4_name: "डॉ. संदेश शर्मा",
    doctor4_role: "बैरिएट्रिक सर्जरी विशेषज्ञ",
    doctor4_desc: "न्यूनतम इनवेसिव वजन घटाने की सर्जरी में विशेषज्ञता रखने वाले कुशल लेप्रोस्कोपिक सर्जन।",
    
    // Procedures
    procedures_title: "प्रदान की जाने वाली प्रक्रियाएं",
    procedures_subtitle: "उन्नत सर्जिकल और एंडोस्कोपिक विकल्प",
    endoscopic_title: "एंडोस्कोपिक प्रक्रियाएं",
    surgical_title: "सर्जिकल प्रक्रियाएं",
    procedure1: "एंडोस्कोपिक स्लीव गैस्ट्रोप्लास्टी (ESG)",
    procedure2: "गैस्ट्रिक बैलून",
    procedure3: "लेप्रोस्कोपिक स्लीव गैस्ट्रेक्टोमी",
    procedure4: "गैस्ट्रिक बाईपास",
    procedure5: "मिनी गैस्ट्रिक बाईपास",
    
    // Clinics
    clinics_title: "विशेष क्लीनिक",
    clinics_subtitle: "एकीकृत रोग प्रबंधन",
    clinic1_title: "मेटाबॉलिक क्लीनिक",
    clinic1_desc: "चयापचय सिंड्रोम प्रबंधन और रोकथाम के लिए विशेष क्लीनिक।",
    clinic2_title: "डायबेसिटी क्लीनिक",
    clinic2_desc: "मधुमेह और मोटापे से संबंधित सह-रुग्णताओं के एकीकृत प्रबंधन के लिए समर्पित क्लीनिक।",
    
    // Contact
    contact_title: "अपना अपॉइंटमेंट बुक करें",
    contact_subtitle: "आज ही अपना परिवर्तन शुरू करें",
    contact_address: "120-121, E-3, अरेरा कॉलोनी, भोपाल",
    contact_phone1: "+91-755-4055123",
    contact_phone2: "+91-9300951215",
    contact_online: "ऑनलाइन बुकिंग",
    contact_online_desc: "HexaHealth या हमारी आधिकारिक वेबसाइट के माध्यम से बुक करें",
    form_name: "पूरा नाम",
    form_email: "ईमेल पता",
    form_phone: "फोन नंबर",
    form_service: "सेवा चुनें",
    form_date: "पसंदीदा तिथि",
    form_message: "आपका संदेश (वैकल्पिक)",
    form_submit: "अपॉइंटमेंट अनुरोध जमा करें",
    form_success: "धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे।",
    
    // Footer
    footer_tagline: "विशेषज्ञ मोटापा देखभाल के माध्यम से जीवन को बदलना",
    footer_rights: "सर्वाधिकार सुरक्षित",
    footer_disclaimer: "यह केवल सूचनात्मक उद्देश्यों के लिए है। चिकित्सा सलाह या निदान के लिए, किसी पेशेवर से परामर्श करें।",
    
    // WhatsApp
    whatsapp_text: "हमसे चैट करें",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'hi' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
